import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Link } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { Button } from "@/components/ui/button"
import {
  FirmBusinessActivities,
  FirmIdentityDetails,
} from "@/features/firms/components/firm-identity-details"
import { FirmYearDetails } from "@/features/firms/components/firm-year-details"
import { firmQueries } from "@/queries/firms"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/details/"
)({
  staticData: { attention: "firm.details" },
  component: FirmRecordPage,
})

function FirmRecordPage() {
  const { firmId } = Route.useParams()
  const { data: firm } = useSuspenseQuery(firmQueries.detail(firmId))

  return (
    <>
      <PageHeader
        title="Firm information"
        actions={
          <Button
            nativeButton={false}
            render={
              <Link
                from="/$organisation"
                to="/$organisation/firms/$firmId/details/edit"
                params={{ firmId }}
              >
                Edit
              </Link>
            }
          />
        }
      />
      <PageContent>
        <FirmIdentityDetails firm={firm} />
        <FirmBusinessActivities firm={firm} />
        <FirmYearDetails firm={firm} />
      </PageContent>
    </>
  )
}
